import Feedable from './feedable'
import LocalStorageManager from './localStorageManager'

export default abstract class Store extends Feedable {
    public abstract signature(): string

    public abstract baseState(): any

    /**
     * Define persistent data.
     * @param model From Local Storage.
     */
    public abstract feed(model: any): this

    public init() {
        return this.feed(this.reload())
    }

    public reload() {
        return LocalStorageManager.load(this.signature(), this.baseState())
    }
    public clear() {
        LocalStorageManager.save(this.signature(), this.baseState())
        this.feed(this.reload())
    }
    public save() {
        LocalStorageManager.save(this.signature(), this)
    }
}
